import { createRoute, lazyRouteComponent } from "@tanstack/react-router";
import { z } from "zod";
import { rootRoute } from "./root";

const trackingParamsSchema = z.object({
  trackingId: z.string().optional(),
  testTracking: z.boolean().optional(),
});

export const trackingRoute = createRoute({
  path: "/$locale/tracking/$trackingId",
  validateSearch: (search: Record<string, unknown>) => {
    const result = trackingParamsSchema.safeParse(search);
    return result.success ? result.data : {};
  },
  getParentRoute: () => rootRoute,
  component: lazyRouteComponent(() => import("../pages/tracking")),
});
